var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M9.358 1.163L4.12 7.026 2.555 5.495a1.134 1.134 0 0 0-1.687.111l-.028.036a1.418 1.418 0 0 0 .13 1.891L3.385 9.9a1.135 1.135 0 0 0 1.642-.054l6.043-6.765a1.435 1.435 0 0 0 0-1.912v-.001a1.15 1.15 0 0 0-1.712-.005z"}));
}

Check.defaultProps = {"width":"12","height":"11","viewBox":"0 0 12 11"};

module.exports = Check;

Check.default = Check;
